import isBrowserContext from "helpers/isBrowserContext";

export default (props?: any, settings?: any) => {

    const onComplianceClick = () => {
        switch (props.complianceType) {
            case "CRM Booking form":
                if (isBrowserContext() && typeof (window?.rekomLoadCRMBookingForm) !== "undefined") {
                    window.rekomLoadCRMBookingForm(props.complianceIdentifier, settings?.venueId);
                }
                break;
            case "Booking form":
                if (isBrowserContext() && typeof (window?.rekomLoadBookingForm) !== "undefined") {
                    window.rekomLoadBookingForm(props.complianceIdentifier, settings?.venueId);
                }
                break;
            case "Guest list":
                if (isBrowserContext() && typeof (window?.rekomLoadGuestListForm) !== "undefined") {
                    window.rekomLoadGuestListForm(props.complianceIdentifier, settings?.venueId);
                }
                break;
            case "Dynamic form":
                if (isBrowserContext() && typeof (window?.rekomLoadDynamicForm) !== "undefined") {
                    window.rekomLoadDynamicForm(props.complianceIdentifier, settings?.venueId);
                }
                break;
        }
    };

    return [onComplianceClick];
};